import React, { useEffect, useState, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import InformacoesPaciente from 'views/Wizard/InformacoesPaciente';
import DadosSolicitacao from 'views/Wizard/DadosSolicitacao';
import ItensCirurgia from 'views/Wizard/ItensCirurgia';
import Resumo from 'views/Wizard/Resumo';
import ConfirmacaoPedido from 'views/Wizard/ConfirmacaoPedido';
import MobileStepper from '@material-ui/core/MobileStepper';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { Dialog } from 'primereact/dialog';
import { Button as ButtonPrime } from 'primereact/button';
import { isMobile } from 'react-device-detect';
import { FaSpinner } from 'react-icons/fa';
import 'assets/css/geral.css';
import { Toast } from 'primereact/toast';
import { isValid, isAfter, isBefore } from 'date-fns';
import Parser from 'html-react-parser';
import { Today } from '@material-ui/icons';
import MinhasDemandas from 'views/MinhasDemandas/MinhasDemandas';
import moment from 'moment';
import {
  iniciaPilhaPendencias,
  getConfiguracoes,
  setPendencia,
  PendenciasWizard,
} from './ValidacaoWizard';
import { dominioDemandaCirurgica, dominioNODE, dominioOperaAspNet } from '../../config/database';
import DataCirurgia from './DataCirurgia';

const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: '80vw',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

const steps = ['Paciente', 'Solicitação', 'Cirurgia', 'Itens', 'Resumo'];
const stepInicial = 0;

export default function Wizard() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});
  const [redireciona, setRedireciona] = useState(false);
  const [displayBasic, setDisplayBasica] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mensagemLoading, setMensagemLoading] = useState('');
  const [tituloErro, setTituloErro] = React.useState('');
  const [abrirMensagemErro, setAbrirMensagemErro] = useState(false);
  const [mensagemErro, setMensagemErro] = useState('');
  const [configuracoes, setConfiguracoes] = useState(null);
  const [abrirDialogConfirmacaoResetaPaciente, setAbrirDialogConfirmacaoResetaPaciente] = useState(
    false
  );
  const [confirmouSalaCirurgica, setConfirmouSalaCirurgica] = useState(false);
  const [tituloConfirmacaoSalaCirurgica, setTituloConfirmacaoSalaCirurgica] = React.useState('');
  const [mensagemConfirmacaoSalaCirurgica, setMensagemConfirmacaoSalaCirurgica] = useState('');
  const [abrirDialogConfirmacaoSalaCirurgica, setAbrirDialogConfirmacaoSalaCirurgica] = useState(
    false
  );
  const [idSalaCirurgia, setIDSalaCirurgia] = useState(null);
  const [finalEfetivoCirurgia, setFinalEfetivoCirurgia] = useState(null);
  const [modalidadeAmbulatorial, setModalidadeAmbulatorial] = React.useState(JSON.parse(localStorage.getItem('configuracoes'))?.modalidadeAmbulatorial);

  const myToast = useRef(null);

  useEffect(() => {
    setConfiguracoes(JSON.parse(localStorage.getItem('configuracoes')));
    const step = localStorage.getItem('activeStep');
    if (step) setActiveStep(parseInt(step, 10));
    incluirPedido();
    verificarDemanda();
  }, []);

  useEffect(() => {
    if (confirmouSalaCirurgica) handleConfirmarPedido();
  }, [confirmouSalaCirurgica]);

  useEffect(() => {
    localStorage.setItem('activeStep', activeStep);
    localStorage.setItem('completed', Object.keys(completed).length);
  }, [activeStep, completed]);

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const limparLocalStorage = () => {
    localStorage.setItem('activeStep', '0');
    localStorage.removeItem('convenio');
    localStorage.removeItem('peso');
    localStorage.removeItem('completed');
    localStorage.removeItem('paciente');
    localStorage.removeItem('dadosSolicitacao');
    localStorage.removeItem('faa');
    localStorage.removeItem('atendimento');
    localStorage.removeItem('data_atendimento');
    localStorage.removeItem('seq_atendimento');
    localStorage.removeItem('carater');
    localStorage.removeItem('profissionalResponsavel');
    localStorage.removeItem('dataSugerida');
    localStorage.removeItem('centroCirurgico');
    localStorage.removeItem('lateralidade');
    localStorage.removeItem('indicacaoClinica');
    localStorage.removeItem('prioridade');
    localStorage.removeItem('cidPrincipal');
    localStorage.removeItem('cidsSecundarios');
    localStorage.removeItem('tipoAcomodacao');
    localStorage.removeItem('diariasPrevistas');
    localStorage.removeItem('leitoUTI');
    localStorage.removeItem('tipoAnestesia');
    localStorage.removeItem('caixasOPME');
    localStorage.removeItem('materiaisConsumiveis');
    localStorage.removeItem('caixasCirurgicas');
    localStorage.removeItem('hemoderivados');
    localStorage.removeItem('procedimentoPrincipal');
    localStorage.removeItem('procedimentosSecundarios');
    localStorage.removeItem('documentos');
    localStorage.removeItem('pedidoCirurgia');
    localStorage.removeItem('equipamentos');
    localStorage.removeItem('duracaoEstimada');
    localStorage.removeItem('email');
    localStorage.removeItem('celular');
    localStorage.removeItem('telefone');
    localStorage.removeItem('exames');
    localStorage.removeItem('dataInternacao');
    localStorage.removeItem('motivoAntecipacaoInternacao');
    localStorage.removeItem('avaliacaoAnestesica');
    localStorage.removeItem('motivoAvaliacaoAnestesica');
    localStorage.removeItem('modalidadeAtendimento');
    localStorage.removeItem('novoPaciente');
    localStorage.removeItem('tipoPedido');
    localStorage.removeItem('centroCirurgicoPermitido');
    localStorage.removeItem('caraterAtendimentoPermitido');
    localStorage.removeItem('lateralidadePermitida');
    localStorage.removeItem('cidPrincipalPermitido');
    localStorage.removeItem('cidSecundarioPermitido');
    localStorage.removeItem('tipoAcomodacaoPermitido');
    localStorage.removeItem('motivoAntecipacaoPermitido');
    localStorage.removeItem('tipoAnestesiaPadrao');
    localStorage.removeItem('procedimentoPrincipalPermitido');
    localStorage.removeItem('procedimentoSecundarioPermitido');
    localStorage.removeItem('caixaOPMEPermitida');
    localStorage.removeItem('materialConsumivelPermitido');
    localStorage.removeItem('caixaCirurgicaPermitida');
    localStorage.removeItem('hemocomponentePermitido');
    localStorage.removeItem('equipamentoPermitido');
    localStorage.removeItem('pedidoCirurgiaVemDoModelo');
    localStorage.removeItem('salaCirurgia');
    localStorage.removeItem('demandaId');
    localStorage.removeItem('listaModalidadeAtendimento');
    localStorage.removeItem('temAtendimento');
    localStorage.removeItem('principaisSinaisSintomas');
    localStorage.removeItem('principaisResultadosProvasDiagnosticas');
    localStorage.removeItem('recursosNecessariosAtendimentoPaciente');
    localStorage.removeItem('historiaClinica');
    localStorage.removeItem('areaMedica');
    localStorage.removeItem('eOncologica');
  };

  const verificaPendenciasStep = step => {
    const tipoPedidoSuplementar = '1';
    const tipoPedido = localStorage.getItem('tipoPedido');
    const novoPaciente = localStorage.getItem('novoPaciente');

    if (step === 0) {
      if (tipoPedido === tipoPedidoSuplementar) {
        if (novoPaciente) {
          const pendenciasPaciente = JSON.parse(
            localStorage.getItem('pendenciasNovoPacienteSuplementar')
          );
          if (pendenciasPaciente.length > 0) {
            let arrayMensagens = [];
            pendenciasPaciente.forEach(validacao => {
              arrayMensagens = [
                ...arrayMensagens,
                {
                  severity: 'warn',
                  summary: 'Atenção',
                  detail: `Informe o ${validacao}`,
                  life: '3000',
                },
              ];
            });
            myToast.current.show(arrayMensagens);
            return false;
          }
        } else {
          const pendenciasPaciente = JSON.parse(
            localStorage.getItem('pendenciasPacienteSuplementar')
          );
          if (pendenciasPaciente.length > 0) {
            let arrayMensagens = [];
            pendenciasPaciente.forEach(validacao => {
              arrayMensagens = [
                ...arrayMensagens,
                {
                  severity: 'warn',
                  summary: 'Atenção',
                  detail: `Informe o(s) ${validacao}`,
                  life: '3000',
                },
              ];
            });
            myToast.current.show(arrayMensagens);
            return false;
          }
        }
      } else {
        const pendenciasPaciente = JSON.parse(localStorage.getItem('pendenciasPaciente'));
        if (pendenciasPaciente.length > 0) {
          let arrayMensagens = [];
          pendenciasPaciente.forEach(validacao => {
            arrayMensagens = [
              ...arrayMensagens,
              {
                severity: 'warn',
                summary: 'Atenção',
                detail: `Informe ${validacao}`,
                life: '3000',
              },
            ];
          });
          myToast.current.show(arrayMensagens);
          return false;
        }
        const email = localStorage.getItem('email');

        if (email && email !== 'null') {
          if (!email.includes('@')) {
            myToast.current.show({
              severity: 'warn',
              summary: 'Atenção',
              detail: 'Formato inválido de email',
            });
            return false;
          }
        }
        const peso = localStorage.getItem('peso');
        if (peso) {
          try {
            const nPeso = parseFloat(peso);
            if (nPeso < 0) {
              myToast.current.show({
                severity: 'warn',
                summary: 'Atenção',
                detail: 'Peso nao pode ser negativo',
              });
              return false;
            }
            if (nPeso > 500) {
              myToast.current.show({
                severity: 'warn',
                summary: 'Atenção',
                detail: 'Peso nao pode ser maior que 500kg',
              });
              return false;
            }
          } catch {
            myToast.current.show({
              severity: 'warn',
              summary: 'Atenção',
              detail: 'Peso inválido',
            });

            return false;
          }
        }
      }
    }
    if (step >= 1) {
      const pendenciasSolicitacao = JSON.parse(localStorage.getItem('pendenciasSolicitacao'));

      const pendenciasCirurgia = JSON.parse(localStorage.getItem('pendenciasCirurgia'));

      const arrayMensagensModeloPedidoCirurgia = [];

      const duracaoEstimada = localStorage.getItem('duracaoEstimada');
      let duracaoEstimadaFormatted = null;
      if (duracaoEstimada) {
        duracaoEstimadaFormatted = JSON.parse(duracaoEstimada);
      }
      const duracaoEstimadaMinimaPermitida = localStorage.getItem('duracaoEstimadaMinimaPermitida');
      const duracaoEstimadaMaximaPermitida = localStorage.getItem('duracaoEstimadaMaximaPermitida');
      if (duracaoEstimadaMinimaPermitida && duracaoEstimadaMaximaPermitida) {
        if (
          duracaoEstimadaFormatted < duracaoEstimadaMinimaPermitida ||
          duracaoEstimadaFormatted > duracaoEstimadaMaximaPermitida
        ) {
          arrayMensagensModeloPedidoCirurgia.push({
            severity: 'warn',
            summary: 'Atenção',
            detail: `A duração estimada deve estar entre ${duracaoEstimadaMinimaPermitida} minutos e ${duracaoEstimadaMaximaPermitida} minutos!`,
            life: '3000',
          });
        }
      }

      if (arrayMensagensModeloPedidoCirurgia.length > 0) {
        myToast.current.show(arrayMensagensModeloPedidoCirurgia);
        return false;
      }

      if (pendenciasSolicitacao.length > 0) {
        let arrayMensagens = [];
        pendenciasSolicitacao.forEach(validacao => {
          arrayMensagens = [
            ...arrayMensagens,
            {
              severity: 'warn',
              summary: 'Atenção',
              detail: `Informe ${validacao}`,
              life: '3000',
            },
          ];
        });
        myToast.current.show(arrayMensagens);
        return false;
      }
    }

    /*
    if (step >= 2) {
      const pendenciasCirurgia = JSON.parse(localStorage.getItem('pendenciasCirurgia'));

      const arrayMensagensModeloPedidoCirurgia = [];

      const duracaoEstimada = localStorage.getItem('duracaoEstimada');
      let duracaoEstimadaFormatted = null;
      if (duracaoEstimada) {
        duracaoEstimadaFormatted = JSON.parse(duracaoEstimada);
      }
      const duracaoEstimadaMinimaPermitida = localStorage.getItem('duracaoEstimadaMinimaPermitida');
      const duracaoEstimadaMaximaPermitida = localStorage.getItem('duracaoEstimadaMaximaPermitida');
      if (duracaoEstimadaMinimaPermitida && duracaoEstimadaMaximaPermitida) {
        if (
          duracaoEstimadaFormatted < duracaoEstimadaMinimaPermitida ||
          duracaoEstimadaFormatted > duracaoEstimadaMaximaPermitida
        ) {
          arrayMensagensModeloPedidoCirurgia.push({
            severity: 'warn',
            summary: 'Atenção',
            detail: `A duração estimada deve estar entre ${duracaoEstimadaMinimaPermitida} minutos e ${duracaoEstimadaMaximaPermitida} minutos!`,
            life: '3000',
          });
        }
      }

      if (arrayMensagensModeloPedidoCirurgia.length > 0) {
        myToast.current.show(arrayMensagensModeloPedidoCirurgia);
        return false;
      }

      if (pendenciasCirurgia.length > 0) {
        let arrayMensagens = [];
        pendenciasCirurgia.forEach(validacao => {
          arrayMensagens = [
            ...arrayMensagens,
            {
              severity: 'warn',
              summary: 'Atenção',
              detail: `Informe ${validacao}`,
              life: '3000',
            },
          ];
        });
        myToast.current.show(arrayMensagens);
        return false;
      }
    }
    */

    if (step >= 2) {
      const modalidadeAtendimento = JSON.parse(localStorage.getItem('modalidadeAtendimento'));

      let dataSugerida = Date.parse(localStorage.getItem('dataSugerida'));
      const hoje = new Date().setHours(0, 0, 0, 0);
      if (isAfter(hoje, dataSugerida)) {
        myToast.current.show({
          severity: 'warn',
          summary: 'Atenção',
          detail: 'Data não pode ser retroativa',
        });
        return false;
      }

      if (!isValid(dataSugerida)) {
        myToast.current.show({
          severity: 'warn',
          summary: 'Atenção',
          detail: 'Data inválida',
        });
        return false;
      }

      let dataInternacao = null;
      const motivoAntecipacaoInternacao = localStorage.getItem('motivoAntecipacaoInternacao') ?? null;
      let internacao = localStorage.getItem('internacao');

      if (internacao?.SEQ_INTERNACAO === null || internacao?.SEQ_INTERNACAO === undefined)
        internacao = null;

      if (localStorage.getItem('dataInternacao') === ('undefined' || null))
        localStorage.removeItem('dataInternacao');
      else {
        dataInternacao = Date.parse(localStorage.getItem('dataInternacao'));
      }

      if (!internacao) {
        if (dataInternacao) {
          dataSugerida = new Date(localStorage.getItem('dataSugerida'));
          dataInternacao = new Date(localStorage.getItem('dataInternacao'));
          dataInternacao.setDate(dataInternacao.getDate() + 1);

          const dataSugeridaSemHoras = new Date(dataSugerida.getFullYear(), dataSugerida.getMonth(), dataSugerida.getDate());
          const dataInternacaoSemHoras = new Date(dataInternacao.getFullYear(), dataInternacao.getMonth(), dataInternacao.getDate());

          if (isBefore(dataInternacaoSemHoras, dataSugeridaSemHoras) && motivoAntecipacaoInternacao === null) {
            myToast.current.show({
              severity: 'warn',
              summary: 'Atenção',
              detail: 'É necessário informar o motivo da internação antecipada!',
            });

            return false;
          }
        } else if (modalidadeAtendimento?.id !== modalidadeAmbulatorial) {
          myToast.current.show({
            severity: 'warn',
            summary: 'Atenção',
            detail: 'É necessário informar a data de internação',
          });

          return false;
        }
      }
    }

    return true;
  };

  const handleCriaPacienteSuplementar = async novoPaciente => {
    setMensagemLoading('Criando paciente');

    novoPaciente.sexo = novoPaciente.sexo.value;

    const retorno = Promise.resolve(
      dominioOperaAspNet
        .post(`/api/criarPacienteSuplementar`, novoPaciente)
        .then(res => {
          setMensagemLoading('');
          setLoading(false);
          novoPaciente.numeroProntuario = res.data.prontuario;
          novoPaciente.idLegado = res.data.seqPaciente;
          localStorage.setItem('novoPaciente', JSON.stringify(novoPaciente));
          myToast.current.show({
            severity: 'success',
            summary: 'Atenção',
            detail: `Novo prontuário criado: ${res.data.prontuario}`,
            life: '10000',
          });
          return true;
        })
        .catch(err => {
          myToast.current.show({
            severity: 'error',
            summary: 'Atenção',
            detail: `Erro ao incluir paciente: ${err}`,
            life: '10000',
          });
          setMensagemLoading('');
          setLoading(false);
          return false;
        })
    );

    return retorno;
  };

  const handleUtilizarPacienteDuplicado = pacienteDuplicado => {
    const paciente = {
      CELULAR: pacienteDuplicado.celular,
      COD_SEXO: pacienteDuplicado.cod_sexo,
      DAT_NASCIMENTO: pacienteDuplicado.dat_nascimento,
      EMAIL: pacienteDuplicado.email,
      NOM_MAE: pacienteDuplicado.nom_mae,
      NOM_PESSOA: pacienteDuplicado.nom_pessoa,
      NRO_CPF: pacienteDuplicado.nro_cpf,
      NRO_PRONTUARIO: pacienteDuplicado.nro_prontuario,
      SEQ_PACIENTE: pacienteDuplicado.seq_paciente,
      TELEFONE: pacienteDuplicado.telefone,
    };
    localStorage.setItem('paciente', JSON.stringify(paciente));
    localStorage.removeItem('novoPaciente');
    setActiveStep(1);
  };

  const handleVerificaPacienteDuplicado = async step => {
    if (step === 0) {
      const { cpf, cns, nome, nomeMae } = JSON.parse(localStorage.getItem('novoPaciente'));

      if (cpf) {
        setLoading(true);
        const verifica = await Promise.resolve(
          dominioOperaAspNet
            .get(`/api/verificarPacienteDuplicado/${cpf}/${cns}/${nome}/${nomeMae}`)
            .then(async res => {
              const { pacienteDuplicado, nro_prontuario } = res.data;

              if (pacienteDuplicado) {
                myToast.current.show({
                  severity: 'info',
                  life: '10000',
                  content: (
                    <div className="p-toast-message-text">
                      <span className="p-toast-summary">Atenção</span>
                      <div className="p-toast-detail">
                        <p>
                          {`Paciente que está sendo cadastrado já existe na base de dados com o prontuário ${nro_prontuario}`}
                        </p>
                        <p>
                          <ButtonPrime
                            className="p-button-text"
                            style={{ color: '#044868' }}
                            onClick={() => {
                              myToast.current.clear();
                              handleUtilizarPacienteDuplicado(res.data);
                            }}
                          >
                            <strong>Clique aqui para utilizá-lo</strong>
                          </ButtonPrime>
                        </p>
                      </div>
                    </div>
                  ),
                });
                setLoading(false);
                return false;
              }

              const retornoCriarPaciente = await Promise.resolve(
                handleCriaPacienteSuplementar(JSON.parse(localStorage.getItem('novoPaciente')))
              );

              return retornoCriarPaciente;
            })
            .catch(err => {
              myToast.current.show({
                severity: 'error',
                summary: 'Atenção',
                detail: `Erro ao verificar se paciente já é existente na base de dados: ${err}`,
                life: '10000',
              });
              setLoading(false);
              return false;
            })
        );

        return verifica;
      }
      return Promise.resolve(false);
    }

    return Promise.resolve(true);
  };

  const reiniciaPedido = () => {
    limparLocalStorage();
    iniciaPilhaPendencias();
    getConfiguracoes();
    incluirPedido();
    localStorage.setItem('completed', 0);
  };

  const handleStep = step => async () => {
    if (step === 0) {
      setAbrirDialogConfirmacaoResetaPaciente(true);
      return;
    }

    //  Se clicar nele mesmo, evita as verificações
    if (step === activeStep) return;

    //  Ao voltar os steps também evita as verificações
    if (step < activeStep) {
      setActiveStep(step);
      return;
    }

    //  #region Verifica as pendências
    const pendenciasDeAcordo = verificaPendenciasStep(activeStep);

    if (!pendenciasDeAcordo) {
      setActiveStep(activeStep);
      return;
    }

    //  #endregion

    //  #region Verifica paciente duplicados e inclusão de paciente
    let verificaPacienteNovoDuplicado = true;

    const novoPaciente = localStorage.getItem('novoPaciente');

    if (novoPaciente)
      verificaPacienteNovoDuplicado = await Promise.resolve(
        handleVerificaPacienteDuplicado(step - 1)
      );

    if (verificaPacienteNovoDuplicado) {
      const diferencaEntreSteps = step - activeStep;

      if (diferencaEntreSteps === 1) {
        setActiveStep(step);
        const internacao = localStorage.getItem('internacao');
        if (internacao) setPendencia(1, PendenciasWizard.tipoAcomodacao);
      } else {
        myToast.current.show({
          severity: 'info',
          summary: 'Atenção',
          detail: 'Não é possível pular passos.',
          life: '5000',
        });
      }
    }

    //  #endregion
  };

  const handleNext = async () => {
    const pendenciasDeAcordo = verificaPendenciasStep(activeStep);

    if (!pendenciasDeAcordo) {
      setActiveStep(activeStep);
      document.location.href = `${document.location.href.replace(
        '#centroWizard',
        ''
      )}#centroWizard`;
      return;
    }

    let verificaPacienteNovoDuplicado = true;

    const novoPaciente = localStorage.getItem('novoPaciente');

    if (novoPaciente)
      verificaPacienteNovoDuplicado = await Promise.resolve(
        handleVerificaPacienteDuplicado(activeStep)
      );

    if (verificaPacienteNovoDuplicado) {
      setActiveStep(activeStep + 1);
      const internacao = localStorage.getItem('internacao');
      if (internacao) setPendencia(1, PendenciasWizard.tipoAcomodacao);
      document.location.href = `${document.location.href.replace(
        '#centroWizard',
        ''
      )}#centroWizard`;
    }
  };

  const handleBack = () => {
    if (activeStep - 1 === 0) setAbrirDialogConfirmacaoResetaPaciente(true);
    else setActiveStep(activeStep - 1);
    document.location.href = `${document.location.href.replace('#centroWizard', '')}#centroWizard`;
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return <InformacoesPaciente />;
      case 1:
        return <DadosSolicitacao />;
      case 2:
        return <DataCirurgia />;
      case 3:
        return <ItensCirurgia />;
      case 4:
        return <Resumo />;
      default:
        throw new Error('Unknown step');
    }
  }

  //  #region geral
  function incluirPedido() {
    const pedidoCirurgia = localStorage.getItem('pedidoCirurgia');

    if (pedidoCirurgia) return;

    dominioDemandaCirurgica.post('/api/pedidoCirurgia').then(
      response => {
        localStorage.setItem('pedidoCirurgia', JSON.stringify(response.data));
      },
      () => {}
    );
  }

  function verificarDemanda() {
    const idDemanda = localStorage.getItem('demandaId');
    if (idDemanda > 0) {
      setActiveStep(1);
    }
  }
  const handleCancelarPedido = () => {
    limparLocalStorage();

    setActiveStep(0);
    setRedireciona(true);
  };

  const handleConfirmarPedido = async () => {
    setLoading(true);

    const paciente = JSON.parse(localStorage.getItem('paciente'));
    const atendimento = JSON.parse(localStorage.getItem('atendimento'));
    const convenio = JSON.parse(localStorage.getItem('convenio'));
    const peso = localStorage.getItem('peso');
    const carater = JSON.parse(localStorage.getItem('carater'));
    const profissionalResponsavel = JSON.parse(localStorage.getItem('profissionalResponsavel'));
    const dataSugerida = localStorage.getItem('dataSugerida');
    const centroCirurgico = JSON.parse(localStorage.getItem('centroCirurgico'));
    const lateralidade = localStorage.getItem('lateralidade');
    const indicacaoClinica = localStorage.getItem('indicacaoClinica');
    const prioridade = JSON.parse(localStorage.getItem('prioridade'));
    const cidPrincipal = JSON.parse(localStorage.getItem('cidPrincipal'));
    const cidsSecundarios = JSON.parse(localStorage.getItem('cidsSecundarios'));
    const tipoAcomodacao = JSON.parse(localStorage.getItem('tipoAcomodacao'));
    const internacao = JSON.parse(localStorage.getItem('internacao'));
    const diariasPrevistas = localStorage.getItem('diariasPrevistas');
    const leitoUTI = localStorage.getItem('leitoUTI');
    const tipoAnestesia = JSON.parse(localStorage.getItem('tipoAnestesia'));
    const caixasOPME = JSON.parse(localStorage.getItem('caixasOPME'));
    const materiaisConsumiveis = JSON.parse(localStorage.getItem('materiaisConsumiveis'));
    const caixasCirurgicas = JSON.parse(localStorage.getItem('caixasCirurgicas'));
    const hemoderivados = JSON.parse(localStorage.getItem('hemoderivados'));
    const procedimentoPrincipal = JSON.parse(localStorage.getItem('procedimentoPrincipal'));
    const procedimentosSecundarios = JSON.parse(localStorage.getItem('procedimentosSecundarios'));
    const pedidoCirurgia = JSON.parse(localStorage.getItem('pedidoCirurgia'));
    const profissional = JSON.parse(localStorage.getItem('profissional'));
    const equipamentos = JSON.parse(localStorage.getItem('equipamentos'));
    const codigoLeito = paciente?.COD_LEITO;
    let duracaoEstimada = localStorage.getItem('duracaoEstimada');
    if (duracaoEstimada) {
      duracaoEstimada = JSON.parse(duracaoEstimada);
    }
    const telefone = localStorage.getItem('telefone');
    const celular = localStorage.getItem('celular');
    const email = localStorage.getItem('email');
    const exames = JSON.parse(localStorage.getItem('exames'));
    const dataInternacao = localStorage.getItem('dataInternacao');
    const motivoAntecipacaoInternacao = JSON.parse(
      localStorage.getItem('motivoAntecipacaoInternacao')
    );
    const motivoAvaliacaoAnestesica = localStorage.getItem('motivoAvaliacaoAnestesica');
    const avaliacaoAnestesica = JSON.parse(localStorage.getItem('avaliacaoAnestesica'));
    const modalidadeAtendimento = JSON.parse(localStorage.getItem('modalidadeAtendimento'));
    const novoPaciente = JSON.parse(localStorage.getItem('novoPaciente'));
    const tipoPedido = localStorage.getItem('tipoPedido') ?? '0';
    const tipoPedidoSuplementar = '1';
    const salaCirurgia = (localStorage.getItem('salaCirurgia') !== 'undefined') ? JSON.parse(localStorage.getItem('salaCirurgia')) : null;
    const principaisSinaisSintomas = localStorage.getItem('principaisSinaisSintomas');
    const principaisResultadosProvasDiagnosticas = localStorage.getItem(
      'principaisResultadosProvasDiagnosticas'
    );
    const recursosNecessariosAtendimentoPaciente = localStorage.getItem(
      'recursosNecessariosAtendimentoPaciente'
    );
    const historiaClinica = localStorage.getItem('historiaClinica');
    const areaMedica = JSON.parse(localStorage.getItem('areaMedica'));
    const eOncologica = JSON.parse(localStorage.getItem('eOncologica'));

    const codigoProcedimentoSequencial = '041502';

    if (!carater) {
      setTituloErro('Atenção!');
      setMensagemErro('O campo carater é obrigatório.');
      setAbrirMensagemErro(true);
      setLoading(false);
      return;
    }

    if (!profissionalResponsavel) {
      setTituloErro('Atenção!');
      setMensagemErro('O campo profissional responsável é obrigatório.');
      setAbrirMensagemErro(true);
      setLoading(false);
      return;
    }

    if (!dataSugerida) {
      setTituloErro('Atenção!');
      setMensagemErro('O campo data sugerida é obrigatório.');
      setAbrirMensagemErro(true);
      setLoading(false);
      return;
    }

    if (!salaCirurgia) {
      setTituloErro('Atenção!');
      setMensagemErro('O campo sala de cirurgia é obrigatório, selecione a data novamente.');
      setAbrirMensagemErro(true);
      setLoading(false);
      return;
    }

    // const slaCarater =  this.state.slacaraterEletivo;
    // console.log('Carater SLA: ',slaCarater)
    // if (dataSugerida <= slaCarater) {
    //   setTituloErro('Atenção!');
    //   setMensagemErro('A data de Cirurgia deve estar de acordo com o prazo de SLA');
    //   setAbrirMensagemErro(true);
    //   setLoading(false);
    //   return;
    // }

    if (!centroCirurgico) {
      setTituloErro('Atenção!');
      setMensagemErro('O campo centro cirurgico é obrigatório.');
      setAbrirMensagemErro(true);
      setLoading(false);
      return;
    }

    if (!lateralidade) {
      setTituloErro('Atenção!');
      setMensagemErro('O campo lateralidade é obrigatório.');
      setAbrirMensagemErro(true);
      setLoading(false);
      return;
    }

    if (!cidPrincipal) {
      setTituloErro('Atenção!');
      setMensagemErro('O campo CID principal é obrigatório.');
      setAbrirMensagemErro(true);
      setLoading(false);
      return;
    }

    if (!tipoAnestesia) {
      setTituloErro('Atenção!');
      setMensagemErro('O campo tipo de anestesia é obrigatório.');
      setAbrirMensagemErro(true);
      setLoading(false);
      return;
    }

    if (!indicacaoClinica) {
      setTituloErro('Atenção!');
      setMensagemErro('O campo Indicação Cirúrgica é obrigatório.');
      setAbrirMensagemErro(true);
      setLoading(false);
      return;
    }

    if (!modalidadeAtendimento) {
      setTituloErro('Atenção!');
      setMensagemErro('O campo modalidade de atendimento é obrigatório.');
      setAbrirMensagemErro(true);
      setLoading(false);
      return;
    }

    //  #region Validações
    if (parseInt(peso, 10) > 500) {
      setTituloErro('Atenção!');
      setMensagemErro('O peso máximo é 500.');
      setAbrirMensagemErro(true);
      setLoading(false);
      return;
    }

    if (parseInt(diariasPrevistas, 10) > 999) {
      setTituloErro('Atenção!');
      setMensagemErro('O máximo de diárias previstas é 999.');
      setLoading(false);
      setAbrirMensagemErro(true);
      return;
    }

    if (prioridade === null) {
      setTituloErro('Atenção!');
      setMensagemErro('Informe a prioridade da cirurgia.');
      setLoading(false);
      setAbrirMensagemErro(true);
      return;
    }

    if (cidPrincipal === null) {
      setTituloErro('Atenção!');
      setMensagemErro('Informe o CID Principal.');
      setLoading(false);
      setAbrirMensagemErro(true);
      return;
    }

    if (eOncologica === null) {
      setTituloErro('Atenção!');
      setMensagemErro('Informe se é ou não uma cirurgia oncológica.');
      setLoading(false);
      setAbrirMensagemErro(true);
      return;
    }

    if (
      tipoAcomodacao === null &&
      modalidadeAtendimento.descricao !== 'AMBULATORIAL' &&
      (internacao?.SEQ_INTERNACAO === null || internacao?.SEQ_INTERNACAO === undefined)
    ) {
      setTituloErro('Atenção');
      setMensagemErro('Informe o tipo de acomodação.');
      setLoading(false);
      setAbrirMensagemErro(true);
      return;
    }

    if (procedimentoPrincipal === null) {
      setTituloErro('Atenção!');
      setMensagemErro('Informe o procedimento principal.');
      setLoading(false);
      setAbrirMensagemErro(true);
      return;
    }

    if (
      codigoProcedimentoSequencial === procedimentoPrincipal?.codigo.slice(0, 6) &&
      procedimentosSecundarios.length < 2
    ) {
      setTituloErro('Atenção!');
      setMensagemErro('É necessário selecionar no mínimo 2 procedimentos sequenciais.');
      setLoading(false);
      setAbrirMensagemErro(true);
      return;
    }

    if (duracaoEstimada === null || duracaoEstimada === 0) {
      setTituloErro('Atenção!');
      setMensagemErro('Informe a duração estimada.');
      setLoading(false);
      setAbrirMensagemErro(true);
      return;
    }

    if (
      duracaoEstimada < 120 &&
      procedimentoPrincipal?.codigo.slice(0, 6) !== codigoProcedimentoSequencial &&
      !(procedimentoPrincipal?.duracao >= 5 && procedimentoPrincipal?.duracao < 9999)
    ) {
      setTituloErro('Atenção!');
      setMensagemErro(
        'Você não pode fazer um pedido de cirurgia com duração abaixo de 120 minutos'
      );
      setLoading(false);
      setAbrirMensagemErro(true);
      return;
    }

    if (
      (principaisSinaisSintomas === null || principaisSinaisSintomas === undefined) &&
      modalidadeAtendimento.descricao !== 'AMBULATORIAL' &&
      (internacao?.SEQ_INTERNACAO === null || internacao?.SEQ_INTERNACAO === undefined)
    ) {
      setTituloErro('Atenção!');
      setMensagemErro('Informe os principais sinais e sintomas.');
      setLoading(false);
      setAbrirMensagemErro(true);
      return;
    }

    if (
      (principaisResultadosProvasDiagnosticas === null ||
        principaisResultadosProvasDiagnosticas === undefined) &&
      modalidadeAtendimento.descricao !== 'AMBULATORIAL' &&
      (internacao?.SEQ_INTERNACAO === null || internacao?.SEQ_INTERNACAO === undefined)
    ) {
      setTituloErro('Atenção!');
      setMensagemErro('Informe os principais resultados de provas diagnósticas.');
      setLoading(false);
      setAbrirMensagemErro(true);
      return;
    }

    if (
      (recursosNecessariosAtendimentoPaciente === null ||
        recursosNecessariosAtendimentoPaciente === undefined) &&
      modalidadeAtendimento.descricao !== 'AMBULATORIAL' &&
      (internacao?.SEQ_INTERNACAO === null || internacao?.SEQ_INTERNACAO === undefined)
    ) {
      setTituloErro('Atenção!');
      setMensagemErro('Informe os recursos necessários para atendimento ao paciente.');
      setLoading(false);
      setAbrirMensagemErro(true);
      return;
    }

    if (
      (historiaClinica === null || historiaClinica === undefined) &&
      modalidadeAtendimento.descricao !== 'AMBULATORIAL' &&
      (internacao?.SEQ_INTERNACAO === null || internacao?.SEQ_INTERNACAO === undefined)
    ) {
      setTituloErro('Atenção!');
      setMensagemErro('Informe a história clínica.');
      setLoading(false);
      setAbrirMensagemErro(true);
      return;
    }

    if (
      (areaMedica === null || areaMedica === undefined) &&
      modalidadeAtendimento.descricao !== 'AMBULATORIAL' &&
      (internacao?.SEQ_INTERNACAO === null || internacao?.SEQ_INTERNACAO === undefined)
    ) {
      setTituloErro('Atenção!');
      setMensagemErro('Informe a área médica.');
      setLoading(false);
      setAbrirMensagemErro(true);
      return;
    }
    //  #endregion

    let idPaciente = 0;
    let idAtendimento = 0;
    let idInternacao = 0;
    let pendenciaSalaCirurgica;
    let localIdSalaCirurgica = 0;
    let localFinalEfetivoCirurgia = '';
    let fimEfetivo = null;

    if (dataSugerida && duracaoEstimada) {
      fimEfetivo = moment(dataSugerida).add(duracaoEstimada, 'minutes').format('YYYY-MM-DDTHH:mm');

      setIDSalaCirurgia(salaCirurgia.id);
      localIdSalaCirurgica = salaCirurgia.id;
      setFinalEfetivoCirurgia(fimEfetivo);
      localFinalEfetivoCirurgia = fimEfetivo;
    }

    // validacao dos horarios disponveis era feita no back
    /* if (!confirmouSalaCirurgica)
      pendenciaSalaCirurgica = await Promise.resolve(
        dominioDemandaCirurgica
          .get(
            `/api/recuperarSalaCirurgica/${dataSugerida}/${duracaoEstimada}/${carater.id}/${profissional.profissional_id}/${salaCirurgia.id}/${profissional.equipe_id}/${centroCirurgico.id}`
          )
          .then(
            response => {
              if (response.data.mensagem === null) {
                setIDSalaCirurgia(response.data.salaCirurgica.id);
                localIdSalaCirurgica = response.data.salaCirurgica.id;
                setFinalEfetivoCirurgia(response.data.finalEfetivoCirurgia);
                localFinalEfetivoCirurgia = response.data.finalEfetivoCirurgia;
                return false;
              }

              if (response.data.bloqueada) {
                setTituloErro('Envio de Pedido Negado');
                setMensagemErro(response.data.mensagem);
                setAbrirMensagemErro(true);
              } else {
                setIDSalaCirurgia(response.data.salaCirurgica.id);
                localIdSalaCirurgica = response.data.salaCirurgica.id;
                setFinalEfetivoCirurgia(response.data.finalEfetivoCirurgia);
                localFinalEfetivoCirurgia = response.data.finalEfetivoCirurgia;
                setTituloConfirmacaoSalaCirurgica('Atenção!');
                setMensagemConfirmacaoSalaCirurgica(response.data.mensagem);
                setAbrirDialogConfirmacaoSalaCirurgica(true);
              }
              setLoading(false);
              return true;
            },
            err => {
              setTituloErro('Erro ao enviar pedido');
              setMensagemErro(err.response.data.mensagem);
              setLoading(false);
              setAbrirMensagemErro(true);
            }
          )
      ); */

    if (pendenciaSalaCirurgica) return;

    try {
      const dataNascimento = new Date(novoPaciente?.dataNascimento ?? paciente.DAT_NASCIMENTO);
      dataNascimento.setDate(dataNascimento.getDate() + 1);
      dataNascimento.setMonth(dataNascimento.getMonth());
      const dataNascimentoFormat = `${dataNascimento.getFullYear()}-${(
        dataNascimento.getMonth() + 1
      )
        .toString()
        .padStart(2, '0')}-${dataNascimento
        .getDate()
        .toString()
        .padStart(2, '0')}`;

      const dadosPaciente = {
        idLegado: novoPaciente?.idLegado ?? paciente.SEQ_PACIENTE,
        numeroProntuario: novoPaciente?.numeroProntuario ?? paciente.NRO_PRONTUARIO,
        nome: novoPaciente?.nome ?? paciente.NOM_PESSOA,
        dataNascimento: dataNascimentoFormat,
        sexo: novoPaciente?.sexo.value ?? novoPaciente?.sexo ?? paciente.COD_SEXO,
        email: novoPaciente?.email ?? email,
        telefone: novoPaciente?.telefone ?? telefone,
        celular: novoPaciente?.celular ?? celular,
        cpf: novoPaciente?.cpf,
        cns: novoPaciente?.cns,
        nomeMae: novoPaciente?.nomeMae,
        GMR: paciente?.GMR === 'S' ?? undefined,
      };

      const [responsePaciente] = await Promise.all([
        dominioDemandaCirurgica.post('/api/paciente', dadosPaciente),
      ]);

      idPaciente = responsePaciente.data.id;

      const dadosAtendimento = {
        idLegado: atendimento?.SEQ_ATENDIMENTO ?? paciente?.SEQ_ATENDIMENTO,
        dataAtendimento: atendimento?.DAT_HORA_ATENDIMENTO ?? paciente?.DAT_HORA_ATENDIMENTO,
        numeroFAA: atendimento?.NRO_FAA ?? paciente?.NRO_FAA,
        peso: parseInt(peso, 10),
        convenio: convenio.id,
      };

      const [responseAtendimento] = await Promise.all([
        dominioDemandaCirurgica.post('/api/atendimento', dadosAtendimento),
      ]);

      idAtendimento = responseAtendimento.data.id;

      let dataInternacaoFormat;

      if (dataInternacao) dataInternacaoFormat = new Date(dataInternacao).toISOString();
      else if (internacao?.DAT_HORA_INTERNACAO)
        dataInternacaoFormat = new Date(dataSugerida).toISOString();

      const dadosInternacao = {
        diariasPrevistas: parseInt(diariasPrevistas, 10),
        leitoUTI: leitoUTI === 'true',
        tipoAcomodacao: tipoAcomodacao ? tipoAcomodacao.id : null,
        dataInternacao: internacao
          ? internacao.DAT_HORA_INTERNACAO
            ? internacao.DAT_HORA_INTERNACAO
            : dataInternacaoFormat
          : dataInternacaoFormat,
        idLegado: internacao ? internacao.SEQ_INTERNACAO : undefined,
        numeroInternacao: internacao ? internacao.NRO_INTERNACAO : undefined,
        convenio: convenio.id,
        peso: parseInt(peso, 10),
      };

      const [responseInternacao] = await Promise.all([
        dominioDemandaCirurgica.post('/api/internacao', dadosInternacao),
      ]);

      idInternacao = responseInternacao.data.id;

      const idModeloPedidoCirurgia = JSON.parse(localStorage.getItem('idModeloPedidoCirurgia'));

      const dadosPedido = {
        atendimento: idAtendimento,
        paciente: idPaciente,
        status: configuracoes.statusInicial,
        motivoRejeicao: '',
        profissionalRequisitante: profissional.profissional_id,
        dataHoraSugerida: dataSugerida,
        caraterAtendimento: carater.id,
        profissionalResponsavel: profissionalResponsavel.id,
        centroCirurgico: centroCirurgico.id,
        salaCirurgia: localIdSalaCirurgica ?? 1,
        lateralidade,
        indicacaoClinica,
        cidPrincipal: cidPrincipal.id,
        cidSecundario: cidsSecundarios ? cidsSecundarios.map(cid => cid.id) : [],
        prioridadeCirurgia: prioridade.id,
        internacao: idInternacao,
        tipoAnestesia: tipoAnestesia.id,
        procedimentoPrincipal: procedimentoPrincipal.id,
        quantidadeProcedimentoPrincipal: procedimentoPrincipal.quantidade,
        procedimentoSecundario: procedimentosSecundarios
          ? procedimentosSecundarios.map(proc => {
              const p = { id: proc.id, quantidade: proc.quantidade };
              return p;
            })
          : [],
        confirmado: 1,
        duracaoEstimada,
        equipeRequisitante: profissional.equipe_id,
        dataInternacao,
        motivoAntecipacaoInternacao: motivoAntecipacaoInternacao
          ? motivoAntecipacaoInternacao.id
          : undefined,
        codigoLeitoInternacao: parseInt(codigoLeito, 10),
        necessariaAvaliacaoAnestesica: avaliacaoAnestesica || false,
        motivoAvaliacaoAnestesica,
        modalidadeAtendimento: modalidadeAtendimento.id,
        idModeloPedidoCirurgia,
        ano0: null,
        statusInicial: null,
        principaisSinaisSintomas,
        principaisResultadosProvasDiagnosticas,
        recursosNecessariosAtendimentoPaciente,
        historiaClinica,
        areaMedica: areaMedica?.id ? areaMedica?.id : null,
        eOncologica: eOncologica.id,
      };

      const { statusInicial } = JSON.parse(localStorage.getItem('configuracoes'));

      dominioDemandaCirurgica.get(`/api/statusPedidoDetail/${statusInicial}`);

      const responsePedido = await Promise.resolve(
        dominioDemandaCirurgica.put(`/api/pedidoCirurgia/${pedidoCirurgia.id}`, dadosPedido).then(
          () => {
            const dadosAgendamentoSalaCirurgia = {
              inicioCirurgia: dataSugerida,
              finalEfetivoCirurgia: finalEfetivoCirurgia ?? localFinalEfetivoCirurgia,
              pedidoCirurgia: pedidoCirurgia.id,
            };

            Promise.resolve(
              dominioDemandaCirurgica
                .post(`/api/agendamentoSalaCirurgia`, dadosAgendamentoSalaCirurgia)
                .then(
                  () => {},
                  () => {
                  setLoading(false);
                  setTituloErro('Atenção!');
                  setMensagemErro('Erro ao agendar sala de cirurgia');
                  setAbrirMensagemErro(true);
                  return false;
                })
            );
            return true;
          },
          () => {
            setLoading(false);
            setTituloErro('Atenção!');
            setMensagemErro('Erro ao confirmar pedido');
            setAbrirMensagemErro(true);
            return false;
          }
        )
      );

      if (!responsePedido) return;

      const listaItens = [];
      if (caixasOPME) {
        caixasOPME.forEach(caixa =>
          listaItens.push({
            item: caixa.id,
            quantidade: caixa.quantidade,
            pedidoCirurgia: pedidoCirurgia.id,
            itemEventual: caixa.itemEventual ?? false,
            justificativaEventual: caixa.justificativaEventual ?? null,
          })
        );
      }
      if (materiaisConsumiveis) {
        materiaisConsumiveis.forEach(material =>
          listaItens.push({
            item: material.id,
            quantidade: material.quantidade,
            pedidoCirurgia: pedidoCirurgia.id,
            itemEventual: material.itemEventual ?? false,
            justificativaEventual: material.justificativaEventual ?? null,
          })
        );
      }
      if (hemoderivados) {
        hemoderivados.forEach(hemoderivado =>
          listaItens.push({
            item: hemoderivado.id,
            quantidade: hemoderivado.quantidade,
            pedidoCirurgia: pedidoCirurgia.id,
            unidadeMedida: hemoderivado.unidadeMedida.id,
          })
        );
      }
      if (equipamentos) {
        equipamentos.forEach(equipamento =>
          listaItens.push({
            item: equipamento.id,
            quantidade: 1,
            pedidoCirurgia: pedidoCirurgia.id,
          })
        );
      }
      if (exames) {
        exames.forEach(exame =>
          listaItens.push({
            item: exame.id,
            quantidade: 1,
            pedidoCirurgia: pedidoCirurgia.id,
          })
        );
      }
      if (caixasCirurgicas) {
        caixasCirurgicas.forEach(caixa =>
          listaItens.push({
            item: caixa.id,
            quantidade: 1,
            pedidoCirurgia: pedidoCirurgia.id,
          })
        );
      }
      if (
        (tipoAcomodacao && tipoAcomodacao.exigeParecerNir) ||
        (dadosPedido.codigoLeitoInternacao ?? 0) > 0
      ) {
        listaItens.push({
          item: configuracoes.itemPadraoExigenciaParecerNir,
          quantidade: 1,
          pedidoCirurgia: pedidoCirurgia.id,
        });
      }

      const idDemanda = localStorage.getItem('demandaId');
      if (idDemanda) {
        const dadosDemanda = {
          idDemanda,
          idPedido: pedidoCirurgia.id,
          idProfissional: profissional.profissional_id,
        };
        await Promise.resolve(
          dominioDemandaCirurgica.put(`/api/finalizarTransformacaoDemanda`, dadosDemanda).then(
            () => {
              return true;
            },
            () => {
              setLoading(false);
              setTituloErro('Atenção!');
              setMensagemErro(`Erro ao finalizar demanda. Demanda ID: ${idDemanda}`);
              setAbrirMensagemErro(true);
              return false;
            }
          )
        );
      }

      const configuracoesRecursoSistema = JSON.parse(
        localStorage.getItem('configuracoesRecursoSistema')
      );

      const internacaoBloqueada = modalidadeAtendimento.recursosBloqueados.some(
        recurosBloqueado =>
          recurosBloqueado.id === configuracoesRecursoSistema.internacaoPedidoCirurgia
      );

      configuracoes.itensInclusaoAutomaticaPedidoCirurgia.forEach(itemInclusaoAutomatica => {
        if (!(internacaoBloqueada && itemInclusaoAutomatica === configuracoes.itemPadraoLeito))
          listaItens.push({
            item: itemInclusaoAutomatica,
            quantidade: 1,
            pedidoCirurgia: pedidoCirurgia.id,
          });
      });

      if (tipoPedido === tipoPedidoSuplementar)
        configuracoes.itensInclusaoAutomaticaSaudeSuplementar.forEach(itemInclusaoAutomatica => {
          listaItens.push({
            item: itemInclusaoAutomatica,
            quantidade: 1,
            pedidoCirurgia: pedidoCirurgia.id,
          });
        });

      if (listaItens.length > 0) {
        await Promise.all(
          listaItens.map(async item => {
            await dominioDemandaCirurgica.post('/api/itemPedidoCirurgia', item);
          })
        );
      }
      if (carater.id === configuracoes.caraterUrgencia) {
        await Promise.all([
          dominioDemandaCirurgica.put(
            `/api/finalizarPedidoUrgenciaEmergencia/${pedidoCirurgia.id}`
          ),
        ]);
      }

      const aprovacaoAutomatica = JSON.parse(localStorage.getItem('aprovacaoAutomatica'));
      if (aprovacaoAutomatica) {
        await Promise.all([
          dominioDemandaCirurgica.put(
            `/api/aprovacaoAutomaticaModeloPedidoCirurgia/${pedidoCirurgia.id}`
          ),
        ]);
      }

      const dataLog = {
        id_usuario: profissional.userid,
        username: profissional.username,
        id_pedido: pedidoCirurgia.id,
        tipo: 'Status',
        descricao: 'PEDIDO',
      };

      dominioNODE.post('/logpedido', dataLog).catch(error => {
        console.log(`ERRO AO INCLUIR LOG: ${error}`);
      });

      limparLocalStorage();
      setRedireciona(true);
    } catch (error) {
      setLoading(false);
      setTituloErro('Atenção!');
      setMensagemErro(`Erro ao confirmar pedido: ${error}`);
      setAbrirMensagemErro(true);
      console.log(error);
    }
  };

  const renderFooterDisplay = () => {
    return (
      <div>
        <ButtonPrime
          label="Não"
          icon="pi pi-times"
          onClick={() => setDisplayBasica(false)}
          className="p-button-text"
        />
        <ButtonPrime
          label="Sim"
          icon="pi pi-check"
          onClick={() => handleCancelarPedido()}
          autoFocus
        />
      </div>
    );
  };

  const renderFooterDisplayErro = () => {
    return (
      <div>
        <ButtonPrime
          label="OK"
          icon="pi pi-check"
          onClick={() => setAbrirMensagemErro(false)}
          autoFocus
        />
      </div>
    );
  };

  const renderFooterDisplayConfirmacaoResetaPaciente = () => {
    return (
      <div>
        <ButtonPrime
          label="Confirmar"
          icon="pi pi-check"
          onClick={() => {
            setAbrirDialogConfirmacaoResetaPaciente(false);
            reiniciaPedido();
            setActiveStep(stepInicial);
            document.location.href = `${document.location.href.replace(
              '#centroWizard',
              ''
            )}#centroWizard`;
          }}
          autoFocus
        />
      </div>
    );
  };

  const corpoAvisoResetaPaciente = () => {
    const idDemanda = localStorage.getItem('demandaId');
    if (idDemanda > 0) {
      return (
        <div className="confirmation-content">
          <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
          <span>
            {`  Se voltar para a aba de Paciente, todos os dados do pedido serão perdidos,
            a demanda selecionada não será mais transformada e você iniciará o processo de criação de um pedido de cirurgia.
            Deseja realmente voltar?`}
          </span>
        </div>
      );
    }
    return (
      <div className="confirmation-content">
        <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
        <span>
          {
            '  Se voltar para a aba de Paciente, todos os dados do pedido serão perdidos. Deseja realmente voltar?'
          }
        </span>
      </div>
    );
  };

  const renderFooterDisplayConfirmacaoSalaCirurgica = () => {
    return (
      <div>
        <ButtonPrime
          label="Confirmar"
          icon="pi pi-check"
          onClick={() => {
            setAbrirDialogConfirmacaoSalaCirurgica(false);
            setConfirmouSalaCirurgica(true);
          }}
          autoFocus
        />
      </div>
    );
  };

  if (redireciona) {
    return <Redirect from="/admin" to="/admin/meusPedidos" />;
  }

  //  #endregion

  return (
    <>
      <Toast ref={myToast} />
      <CssBaseline />
      <main className={classes.layout}>
        <Dialog
          header="Atenção"
          visible={abrirDialogConfirmacaoResetaPaciente}
          modal
          style={{ width: '60vw' }}
          footer={renderFooterDisplayConfirmacaoResetaPaciente()}
          onHide={() => setAbrirDialogConfirmacaoResetaPaciente(false)}
        >
          {corpoAvisoResetaPaciente()}
        </Dialog>
        <Dialog
          header={tituloConfirmacaoSalaCirurgica}
          visible={abrirDialogConfirmacaoSalaCirurgica}
          modal
          style={{ width: '60vw' }}
          footer={renderFooterDisplayConfirmacaoSalaCirurgica()}
          onHide={() => setAbrirDialogConfirmacaoSalaCirurgica(false)}
        >
          <div>
            <span style={{ whiteSpace: 'pre-line' }}>
              {Parser(mensagemConfirmacaoSalaCirurgica)}
            </span>
          </div>
        </Dialog>
        <Dialog
          header="Cancelar pedido"
          visible={displayBasic}
          style={{ width: '60vw' }}
          footer={renderFooterDisplay()}
          onHide={() => setDisplayBasica(false)}
        >
          <p>Deseja realmente cancelar?</p>
        </Dialog>
        <Dialog
          header={tituloErro}
          visible={abrirMensagemErro}
          style={{ width: '65vw' }}
          onHide={() => setAbrirMensagemErro(false)}
          footer={renderFooterDisplayErro()}
        >
          <div>
            <span style={{ whiteSpace: 'pre-line' }}>{Parser(mensagemErro)}</span>
          </div>
        </Dialog>
        <Paper className={classes.paper}>
          <Typography component="h1" variant="h4" align="center" id="centroWizard">
            Pedido de Cirurgia
          </Typography>
          {isMobile ? (
            <div>
              <div className="div-stepper-mobile">
                <strong className="texto-stepper-mobile">{`${activeStep + 1} - `}</strong>
                <span className="texto-stepper-mobile">{steps[activeStep]}</span>
              </div>
              <MobileStepper
                variant="dots"
                steps={steps.length}
                position="static"
                activeStep={activeStep}
                className={classes.root}
                nextButton={
                  <Button
                    size="small"
                    onClick={handleNext}
                    disabled={activeStep === steps.length - 1}
                  >
                    Próximo
                    <KeyboardArrowRight />
                  </Button>
                }
                backButton={
                  <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                    <KeyboardArrowLeft />
                    Voltar
                  </Button>
                }
              />
            </div>
          ) : (
            <Stepper nonLinear activeStep={activeStep} className={classes.stepper}>
              {steps.map((label, index) => (
                <Step key={label}>
                  <StepButton
                    disabled={activeStep === steps.length}
                    onClick={handleStep(index)}
                    completed={completed[index]}
                  >
                    {label}
                  </StepButton>
                </Step>
              ))}
            </Stepper>
          )}
          <>
            {activeStep === steps.length ? (
              <ConfirmacaoPedido />
            ) : (
              <>
                {getStepContent(activeStep)}
                <div
                  className={`${classes.buttons} ${
                    activeStep !== 0 ? 'alinhamento-botoes-wizard' : ''
                  }`}
                >
                  {activeStep !== 0 && (
                    <Button
                      id="btnAnt"
                      tabIndex="-1"
                      onClick={handleBack}
                      className={classes.button}
                      color="default"
                      variant="contained"
                    >
                      Anterior
                    </Button>
                  )}
                  <Button
                    id="btnProx"
                    variant="contained"
                    color="primary"
                    onClick={
                      activeStep === steps.length - 1 ? handleConfirmarPedido : handleComplete
                    }
                    className={classes.button}
                    style={{ float: `` }}
                  >
                    {loading ? (
                      <>
                        <span>{mensagemLoading}</span>
                        <FaSpinner color="#FFF" className="loading" size={14} />
                      </>
                    ) : (
                      <>{activeStep === steps.length - 1 ? 'Enviar' : 'Próximo'}</>
                    )}
                  </Button>
                </div>
              </>
            )}
          </>
        </Paper>
      </main>
    </>
  );
}
